const { createRoot } = require("react-dom/client");
const { default: App } = require("./App");
import "./index.css";

const root = createRoot(document.getElementById("root"));
root.render(<App />);
